import { Typography } from '@app/components';
import { EPlanLimitType } from '@app/domain/plan/components/plan-limit-dialog/PlanLimitDialog';
import { UpgradeBanner } from '@app/domain/plan/components/UpgradeBanner';
import { usePlanLimits } from '@app/domain/plan/hooks/usePlanLimits';
import { AccountSetUpShortURL } from '@app/domain/white-label/components/AccountSetUpShortURL';
import { useTranslation } from 'react-i18next';

export const AccountWhiteLabelPage: React.FC = () => {
  const { t } = useTranslation();
  const { canUseWhiteLabel } = usePlanLimits();

  return (
    <div className="flex flex-col gap-4">
      <Typography className="font-bold text-gray-800 text-xxxl pl-6 lg:pl-0">{t('whiteLabel.title')}</Typography>
      <div className="flex flex-col gap-4">
        {!canUseWhiteLabel && (
          <UpgradeBanner planLimitDialogType={EPlanLimitType.WHITE_LABEL} className="lg:rounded-xl" />
        )}
        <div className="flex flex-col gap-4">
          <AccountSetUpShortURL />
        </div>
      </div>
    </div>
  );
};
